export interface Theme {
  background: string;
  backgroundSecondary: string;
  surface: string;
  surfaceBorder: string;
  border: string;
  borderLight: string;
  text: string;
  textSecondary: string;
  textTertiary: string;
  textInverse: string;
  inputBg: string;
  link: string;
}

// Light mode — neutral backgrounds, blue toolbar + blue borders
export const lightTheme: Theme = {
  background: '#ECEAE6',           // haze — warm neutral page
  backgroundSecondary: '#E2DED8',  // mist — sidebar, secondary panels
  surface: '#E2DED8',              // mist — card panels
  surfaceBorder: '#8A9CAA',        // distant-ridge — soft blue border
  border: '#8A9CAA',               // distant-ridge — blue dividers
  borderLight: 'rgba(106,126,142,0.25)',  // far-ridge tint — subtle borders
  text: '#2E3840',                 // near-ridge
  textSecondary: '#506272',        // mid-ridge
  textTertiary: '#8A9CAA',         // distant-ridge
  textInverse: '#ECEAE6',          // haze
  inputBg: '#ECEAE6',             // haze
  link: '#B05A48',                 // sunrise-deep
};

export const darkTheme: Theme = {
  background: '#1E2830',           // deeper than near-ridge — true dark base
  backgroundSecondary: '#2E3840',  // near-ridge
  surface: '#2E3840',              // near-ridge — card panels
  surfaceBorder: 'rgba(80,98,114,0.20)',  // mid-ridge tinted
  border: 'rgba(80,98,114,0.16)',         // mid-ridge tinted
  borderLight: 'rgba(80,98,114,0.10)',    // mid-ridge tinted
  text: '#E4E6E8',                 // dark-ridge-wash — cool text
  textSecondary: '#8A9CAA',        // distant-ridge
  textTertiary: '#6A7E8E',        // far-ridge
  textInverse: '#1E2830',         // deep ridge
  inputBg: '#2E3840',             // near-ridge
  link: '#D49880',                 // sunrise-light
};
